(() => {
  if (window.__GZG_CUSTOM_CART_LOADED__) return;
  window.__GZG_CUSTOM_CART_LOADED__ = true;

  let giftBusy = false;
  let giftTimer = null;
  let observer = null;

  const qs = (selector, root = document) => root.querySelector(selector);

  function getRoot() {
    return qs('#CartDrawer.gzg-custom-cart');
  }

  function getConfig() {
    const el = qs('#GZGCustomCartConfig');
    if (!el) return null;

    return {
      giftEnabled: el.dataset.giftEnabled === 'true',
      autoGift: el.dataset.autoGift === 'true',
      giftVariantId: Number(el.dataset.giftVariant || 0),
      giftThreshold: Number(el.dataset.giftThreshold || 0),
    };
  }

  function cartUrl(path) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return `${root}${path}`;
  }

  function sectionPayload(extra = {}) {
    return {
      ...extra,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };
  }

  async function postCart(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Cart request failed');
    }

    return data;
  }

  function refreshRenderedSections(data) {
    if (!data || !data.sections) return;

    const drawer = qs('cart-drawer');
    const currentInner = qs('#CartDrawer .drawer__inner');

    if (data.sections['cart-drawer'] && currentInner) {
      const parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
      const nextInner = parsed.querySelector('#CartDrawer .drawer__inner');

      if (nextInner) {
        currentInner.innerHTML = nextInner.innerHTML;
      }
    }

    if (data.sections['cart-icon-bubble']) {
      const parsedBubble = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      const nextBubble =
        parsedBubble.querySelector('#cart-icon-bubble') ||
        parsedBubble.querySelector('.shopify-section') ||
        parsedBubble.body.firstElementChild;

      const currentBubble = qs('#cart-icon-bubble');

      if (currentBubble && nextBubble) {
        currentBubble.innerHTML = nextBubble.innerHTML;
      }
    }

    if (drawer && typeof data.item_count !== 'undefined') {
      drawer.classList.toggle('is-empty', Number(data.item_count) === 0);
    }

    initVariantDisplays();
  }

  async function getCart() {
    const response = await fetch(cartUrl('cart.js'), {
      headers: { 'Accept': 'application/json' }
    });
    return response.json();
  }

  function findAutoGiftLine(cart) {
    return (cart.items || []).find((item) => {
      return item.properties && String(item.properties._custom_cart_gift) === 'true';
    });
  }

  async function addAutoGift(variantId) {
    return postCart(
      cartUrl('cart/add.js'),
      sectionPayload({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _custom_cart_gift: 'true'
          }
        }]
      })
    );
  }

  async function removeAutoGift(lineKey) {
    return postCart(
      cartUrl('cart/change.js'),
      sectionPayload({
        id: lineKey,
        quantity: 0
      })
    );
  }

  async function syncGift() {
    const config = getConfig();
    if (
      !config ||
      !config.giftEnabled ||
      !config.autoGift ||
      !config.giftVariantId ||
      !config.giftThreshold ||
      giftBusy
    ) {
      return;
    }

    giftBusy = true;

    try {
      const cart = await getCart();
      const giftLine = findAutoGiftLine(cart);
      const giftPrice = giftLine ? Number(giftLine.final_line_price || 0) : 0;
      const qualifyingTotal = Math.max(0, Number(cart.total_price || 0) - giftPrice);

      // item_count can include the gift itself, so also check whether there are non-gift items.
      const nonGiftItemCount = (cart.items || []).reduce((count, item) => {
        const isGift = item.properties && String(item.properties._custom_cart_gift) === 'true';
        return count + (isGift ? 0 : Number(item.quantity || 0));
      }, 0);

      const shouldHaveGift = nonGiftItemCount > 0 && qualifyingTotal >= config.giftThreshold;

      if (shouldHaveGift && !giftLine) {
        const data = await addAutoGift(config.giftVariantId);
        refreshRenderedSections(data);
      } else if (shouldHaveGift && giftLine && Number(giftLine.quantity) !== 1) {
        const data = await postCart(
          cartUrl('cart/change.js'),
          sectionPayload({ id: giftLine.key, quantity: 1 })
        );
        refreshRenderedSections(data);
      } else if (!shouldHaveGift && giftLine) {
        const data = await removeAutoGift(giftLine.key);
        refreshRenderedSections(data);
      }
    } catch (error) {
      console.warn('[Custom Cart] Gift sync skipped:', error);
    } finally {
      giftBusy = false;
    }
  }

  function scheduleGiftSync(delay = 250) {
    clearTimeout(giftTimer);
    giftTimer = setTimeout(syncGift, delay);
  }

  async function addUpsell(button) {
    const card = button.closest('.gzg-upsell');
    if (!card) return;

    const select = qs('.gzg-upsell-variant', card);
    const variantId = Number(select ? select.value : button.dataset.variantId || 0);

    if (!variantId) return;

    const originalText = button.dataset.defaultText || button.textContent.trim();

    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const data = await postCart(
        cartUrl('cart/add.js'),
        sectionPayload({
          items: [{ id: variantId, quantity: 1 }]
        })
      );

      refreshRenderedSections(data);

      const drawer = qs('cart-drawer');
      if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') {
        drawer.open();
      }

      scheduleGiftSync(80);
    } catch (error) {
      console.error('[Custom Cart] Upsell add failed:', error);
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function updateVariantDisplay(select) {
    const option = select.options[select.selectedIndex];
    if (!option) return;

    const card = select.closest('.gzg-upsell');
    if (!card) return;

    const price = qs('.gzg-upsell-price', card);
    const compare = qs('.gzg-upsell-compare', card);
    const image = qs('.gzg-upsell-image', card);
    const button = qs('.gzg-upsell-add', card);

    if (price) price.textContent = option.dataset.price || '';

    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }

    if (image && option.dataset.image) {
      image.src = option.dataset.image;
    }

    if (button) {
      button.dataset.variantId = option.value;
      button.disabled = option.disabled || option.dataset.available !== 'true';
    }
  }

  function initVariantDisplays() {
    document.querySelectorAll('.gzg-upsell-variant').forEach(updateVariantDisplay);
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest && event.target.closest('.gzg-upsell-variant');
    if (select) updateVariantDisplay(select);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('.gzg-upsell-add');
    if (!button) return;

    event.preventDefault();
    addUpsell(button);
  });

  function bindCartEvents() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleGiftSync(220));
      }
    } catch (error) {
      // MutationObserver below remains as a fallback.
    }
  }

  function observeDrawer() {
    const drawer = qs('cart-drawer');
    if (!drawer || observer) return;

    observer = new MutationObserver(() => {
      if (getRoot()) {
        initVariantDisplays();
        scheduleGiftSync(300);
      }
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    if (!getRoot()) return;
    initVariantDisplays();
    bindCartEvents();
    observeDrawer();
    scheduleGiftSync(350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();